/**
 * French URL paths — single source of truth for client-side routing.
 * API paths (e.g. /auth/sign-in, /cars) stay unchanged.
 */

export const PATH = {
  HOME: '/',
  SIGN_IN: '/connexion',
  FORGOT_PASSWORD: '/mot-de-passe-oublie',
  JOIN: '/rejoindre',
  DATA_DELETE: '/suppression-de-donnees',
  DRIVERS: '/conducteurs',
  TRANSACTIONS: '/transactions',
  DOCUMENTS: '/documents',
  NOTIFICATIONS: '/notifications',
  VEHICLES: '/vehicules',
  REVENUES: '/revenus',
};

/** URL segment for the “add vehicle” flow (ajout de véhicule). */
export const ADD_VEHICLE_SLUG = 'ajout';

/** Patterns for <Route path={…} /> */
export const ROUTE_PATTERN = {
  SIGN_IN: PATH.SIGN_IN,
  FORGOT_PASSWORD: PATH.FORGOT_PASSWORD,
  JOIN: PATH.JOIN,
  DATA_DELETE: PATH.DATA_DELETE,
  MAIN_WILDCARD: '/*',
  DRIVERS: PATH.DRIVERS,
  DRIVER: `${PATH.DRIVERS}/:userId`,
  DRIVER_REVENUES: `${PATH.DRIVERS}/:userId${PATH.REVENUES}`,
  DRIVER_VEHICLES: `${PATH.DRIVERS}/:userId${PATH.VEHICLES}`,
  DRIVER_VEHICLE: `${PATH.DRIVERS}/:userId${PATH.VEHICLES}/:carId`,
  TRANSACTIONS: PATH.TRANSACTIONS,
  USER_TRANSACTIONS: `${PATH.TRANSACTIONS}/:userId`,
  DOCUMENTS: PATH.DOCUMENTS,
  NOTIFICATIONS: PATH.NOTIFICATIONS,
};

export const pathDriver = (userId) => `${PATH.DRIVERS}/${userId}`;

export const pathDriverRevenues = (userId) => `${pathDriver(userId)}${PATH.REVENUES}`;

export const pathDriverVehicles = (userId) => `${pathDriver(userId)}${PATH.VEHICLES}`;

export const pathDriverVehicle = (userId, carId) => `${pathDriverVehicles(userId)}/${carId}`;

export const pathUserTransactions = (userId) => `${PATH.TRANSACTIONS}/${userId}`;
